import { isCatalogV2ProductContext } from '@/utils/bcProductMetadataUtils';
import CatalogV1InpageAddToBagButton from './CatalogV1InpageAddToBagButton';
import CatalogV2InpageAddToBagButton from './CatalogV2InpageAddToBagButton';

const InPageAddToBagButton = ({ mobile }: { mobile?: boolean }) => {
  return isCatalogV2ProductContext() ? (
    <CatalogV2InpageAddToBagButton mobile={mobile} />
  ) : (
    <CatalogV1InpageAddToBagButton mobile={mobile} />
  );
};

export default InPageAddToBagButton;
